export default __webpack_public_path__ + "static/media/sample-picture.35100ae9.png";